import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    NumberInput,
    BooleanInput,
    Show,
    SimpleShowLayout,
    DateField,
    Filter,
    ReferenceInput,
    ReferenceField,
    DeleteButton,
    ImageField,
} from 'react-admin';

const CourseFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索标题" source="key" alwaysOn />
        <ReferenceInput source="CategoryId" reference="Admin/CMSTrainingCategory" label="分类" allowEmpty>
            <SelectInput optionText="Name" />
        </ReferenceInput>
        <ReferenceInput source="TeacherId" reference="Admin/CMSTeacher" label="讲师" allowEmpty>
            <SelectInput optionText="Name" />
        </ReferenceInput>
        <SelectInput source="Status" label="状态" choices={[
            { id: 1, name: '已发布' },
            { id: 0, name: '草稿' },
            { id: 2, name: '已下架' },
        ]} />
    </Filter>
);

export const CourseList = props => (
    <List {...props} filters={<CourseFilter />} title="课程管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <ImageField source="Cover" label="封面" />
            <TextField source="Title" label="课程标题" />
            <ReferenceField source="CategoryId" reference="Admin/CMSTrainingCategory" label="分类" allowEmpty>
                <TextField source="Name" />
            </ReferenceField>
            <ReferenceField source="TeacherId" reference="Admin/CMSTeacher" label="讲师" allowEmpty>
                <TextField source="Name" />
            </ReferenceField>
            <TextField source="Duration" label="时长(分钟)" />
            <TextField source="Level" label="难度" />
            <TextField source="StudentCount" label="学员数" />
            <TextField source="Status" label="状态" />
            <DateField source="CreateTime" label="创建时间" showTime />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const CourseEdit = props => (
    <Edit {...props} title="编辑课程">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Title" label="课程标题" fullWidth />
            <TextInput source="Cover" label="封面URL" fullWidth />
            <ReferenceInput source="CategoryId" reference="Admin/CMSTrainingCategory" label="分类">
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <ReferenceInput source="TeacherId" reference="Admin/CMSTeacher" label="讲师">
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <TextInput source="Description" label="简介" multiline fullWidth />
            <TextInput source="Content" label="详细内容" multiline fullWidth />
            <NumberInput source="Duration" label="总时长(分钟)" />
            <SelectInput source="Level" label="难度等级" choices={[
                { id: 1, name: '初级' },
                { id: 2, name: '中级' },
                { id: 3, name: '高级' },
            ]} />
            <NumberInput source="Sort" label="排序" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 1, name: '已发布' },
                { id: 0, name: '草稿' },
                { id: 2, name: '已下架' },
            ]} />
            <BooleanInput source="IsRecommend" label="推荐课程" />
        </SimpleForm>
    </Edit>
);

export const CourseCreate = props => (
    <Create {...props} title="新建课程">
        <SimpleForm>
            <TextInput source="Title" label="课程标题" fullWidth />
            <TextInput source="Cover" label="封面URL" fullWidth />
            <ReferenceInput source="CategoryId" reference="Admin/CMSTrainingCategory" label="分类">
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <ReferenceInput source="TeacherId" reference="Admin/CMSTeacher" label="讲师">
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <TextInput source="Description" label="简介" multiline fullWidth />
            <TextInput source="Content" label="详细内容" multiline fullWidth />
            <NumberInput source="Duration" label="总时长(分钟)" defaultValue={0} />
            <SelectInput source="Level" label="难度等级" defaultValue={1} choices={[
                { id: 1, name: '初级' },
                { id: 2, name: '中级' },
                { id: 3, name: '高级' },
            ]} />
            <NumberInput source="Sort" label="排序" defaultValue={0} />
            <SelectInput source="Status" label="状态" defaultValue={0} choices={[
                { id: 1, name: '已发布' },
                { id: 0, name: '草稿' },
                { id: 2, name: '已下架' },
            ]} />
            <BooleanInput source="IsRecommend" label="推荐课程" defaultValue={false} />
        </SimpleForm>
    </Create>
);
